import { render, staticRenderFns } from "./CollectionSortForm.vue?vue&type=template&id=3837889a&scoped=true&"
import script from "./CollectionSortForm.vue?vue&type=script&lang=js&"
export * from "./CollectionSortForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSortForm.vue?vue&type=style&index=0&id=3837889a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837889a",
  null
  
)

export default component.exports